// Shared formatters + style helpers used across all Planning Command Center sub-pages.
import { apiClient } from "../../App";

export const ALLOWED_ROLES = new Set([
  "Admin", "COO", "Director", "PM", "Sales", "Accountant",
  "Sales Manager", "Production Manager",
]);

export function fmtMoney(v) {
  const n = Number(v || 0);
  return n.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
}

export function fmtMoneyShort(v) {
  const n = Number(v || 0);
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `$${(n / 1_000).toFixed(0)}K`;
  return `$${n.toFixed(0)}`;
}

export function fmtDate(v) {
  if (!v) return "—";
  try { return new Date(v).toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" }); }
  catch { return String(v); }
}

export function fmtDateShort(v) {
  if (!v) return "—";
  try { return new Date(v).toLocaleDateString("en-US", { month: "short", day: "numeric" }); }
  catch { return String(v); }
}

export function healthBadge(h) {
  const v = (h || "").toLowerCase();
  if (["delayed", "high", "critical"].includes(v))
    return { cls: "bg-red-500/15 text-red-300 border-red-500/30", label: "▲ Delayed" };
  if (["at_risk", "at-risk", "medium", "yellow"].includes(v))
    return { cls: "bg-amber-500/15 text-amber-300 border-amber-500/30", label: "▲ At Risk" };
  return { cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30", label: "● On Track" };
}

export function sizeBadgeCls(s) {
  const map = {
    S: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
    M: "bg-blue-500/15 text-blue-300 border-blue-500/30",
    L: "bg-amber-500/15 text-amber-300 border-amber-500/30",
    XL: "bg-red-500/15 text-red-300 border-red-500/30",
  };
  return map[s] || "bg-white/[0.06] text-white/60 border-white/10";
}

export function initialsOf(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase() || parts[0][0].toUpperCase();
}

export async function fetchJson(path, params = {}) {
  const res = await apiClient.get(path, { params });
  return res.data;
}

export function SectionHeader({ dot, title, action }) {
  return (
    <div className="flex items-center justify-between px-6 py-4 border-b border-white/[0.08]">
      <div className="flex items-center gap-2.5">
        <span className="inline-block w-2 h-2 rounded-full" style={{ background: dot || "#B96A43" }} />
        <div className="text-[12px] uppercase tracking-[0.08em] font-semibold text-white">{title}</div>
      </div>
      {action}
    </div>
  );
}
